import dayjs from 'dayjs';
import { LAST_SYNC_DIFF } from '../constants/devices-data.constants';

export const checkDeviceSync = (syncTimestamp: string) => {
  return (
    dayjs(new Date()).diff(dayjs(syncTimestamp), 'm') <= LAST_SYNC_DIFF
  );
};
